'use client';

import { useCallback, useState } from 'react';
import { useApolloClient } from '@apollo/client/react';
import { toast } from 'sonner';
import {
  ITEM_BY_PAEFFGEN_SKU_QUERY,
  type ItemByPaeffgenSKUResult,
  type ItemByPaeffgenSKUVariables,
} from '@paeffgen/react/crm-documents/data-access-graphql';

export interface UseOpenArticleInShopResult {
  open: (articleNumber: string) => Promise<void>;
  isLoading: boolean;
}

export function useOpenArticleInShop(): UseOpenArticleInShopResult {
  const client = useApolloClient();
  const [isLoading, setIsLoading] = useState(false);

  const open = useCallback(
    async (articleNumber: string) => {
      if (!articleNumber) return;
      setIsLoading(true);
      try {
        const { data } = await client.query<
          ItemByPaeffgenSKUResult,
          ItemByPaeffgenSKUVariables
        >({
          query: ITEM_BY_PAEFFGEN_SKU_QUERY,
          variables: { pfgnSKU: articleNumber },
          // network-only: shop status may change between page-load and click
          fetchPolicy: 'network-only',
        });

        const id = data?.getItemByPaeffgenSKU?.id;
        if (!id) {
          toast.error('Dieser Artikel ist im Shop nicht verfügbar');
          return;
        }

        window.open(
          `https://www.dachbaustoffe.de/shop/artikel/${id}`,
          '_blank',
          'noopener,noreferrer'
        );
      } catch (err) {
        console.error('useOpenArticleInShop:', err);
        toast.error('Shop nicht erreichbar – bitte später erneut versuchen');
      } finally {
        setIsLoading(false);
      }
    },
    [client]
  );

  return { open, isLoading };
}
